import { AController } from "@eagerlogic/react-mvc";
import { TeamHolidaysModel, TeamHolidaysItemModel } from "../model/TeamHolidaysModel";
import { TeamHolidaysListResponse, TeamHolidaysRpc } from "rpc/statistics/TeamHolidaysRpc";

export class TeamHolidaysController extends AController<TeamHolidaysModel> {

    public constructor(
        private readonly year: number
    ) {
        super()
    }

    protected createInitialModel(): TeamHolidaysModel {
        var res = new TeamHolidaysModel();

        TeamHolidaysRpc.list(this.year)
            .then((res) => {
                this.render(this.convertDto(res));
            });

        return res;
    }

    public convertDto(dto: TeamHolidaysListResponse): TeamHolidaysModel {
        var res = new TeamHolidaysModel();
        for (var item of dto.items) {
            let im = new TeamHolidaysItemModel();
            im.userId = item.userId;
            im.userName = item.userName;
            im.yearlyVacationCount = item.yearlyVacationCount;
            im.remainingVacationCount = item.remainingVacationCount;
            im.rolledVacationCount = item.rolledVacationCount;
            im.usedUpVacationCount = item.usedUpVacationCount;
            im.otherItems = item.otherItems;
            res.items.push(im);
        }

        for (var extraTitle of dto.extraTitles) {
            res.extraTitles.push(extraTitle);
        }

        return res;
    }

}